import { CommonModule } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { APP_INITIALIZER, inject, NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { NZ_CONFIG, NzConfig } from 'ng-zorro-antd/core/config';
import { NzMessageModule } from 'ng-zorro-antd/message';
import { StatesService } from 'src/app/core/store/states.service';
import { EnsureImportedOnceModule } from './module-import.guard';
import { permissionsInit } from './permissions/permissions-init';

const ngZorroConfig: NzConfig = {
  // 注意组件名称没有 nz 前缀
  message: {
    nzMaxStack: 1,
  },
};

@NgModule({
  imports: [CommonModule, RouterModule, NzMessageModule],
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: permissionsInit,
      deps: [StatesService],
      multi: true,
    },
    { provide: NZ_CONFIG, useValue: ngZorroConfig },
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class CoreModule extends EnsureImportedOnceModule {
  public constructor() {
    const parent = inject(CoreModule, { skipSelf: true, optional: true });

    super(parent);
  }
}
